/* OrgPageTable auto-generated by npm run generator */
import { Link, makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, Typography } from "@material-ui/core"
import MoreVert from "@material-ui/icons/MoreVert"
import clsx from "clsx"
import { useCollectionSubscribe } from "hooks/useSnapshots"
import { observer } from "mobx-react"
import React, { CSSProperties } from "react"
import { Link as RouterLink, useHistory, useParams } from "react-router-dom"
import { PATHS } from "Router"
import Store from "store/Store"
import InviteClinician from "./dialogs/InviteClinician"
import ClinicianMenu from "./dropdowns/ClinicianMenu"
import { useFilterMenu } from "./dropdowns/FilterMenu"

interface OrgPageTableProps {
    className?: string
    style?: CSSProperties
    children?: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
    orgPageTableMolecule: {
        border: `1px solid ${theme.palette.secondary.main}`,
        padding: theme.spacing(4),
    },
    row: {
        cursor: "pointer",
    },
    header: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: theme.spacing(4),
        gridAutoColumns: "max-content",
        alignItems: "center",
        gridTemplateColumns: "auto auto 1fr",
    },
    filter: {
        justifySelf: "flex-end",
        minWidth: 130,
    },

    capitalize: {
        textTransform: "capitalize",
    },
}))

const OrgPageTable: React.FC<OrgPageTableProps> = (props) => {
    const history = useHistory()
    const classes = useStyles()
    const className = clsx(classes.orgPageTableMolecule, props.className)
    const { orgId } = useParams()
    const { orgName } = Store.auth.getOrg(orgId)
    const clinicians = useCollectionSubscribe(Store.auth.clinicianCollection.where("orgId", "==", orgId))
    const { FilterMenu, filteredUsers } = useFilterMenu(clinicians)

    const headers = ["Name", "Role", "Status", "Active Clients", <MoreVert />]

    return (
        <div className={className} style={props.style}>
            <div className={classes.header}>
                <Typography variant="h5" display="inline">
                    Clinician List: {orgName}
                </Typography>
                <InviteClinician />
                <FilterMenu />
            </div>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            {headers.map((header) => (
                                <TableCell key={header.toString()}>{header}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredUsers?.map((user, i) =>
                            user ? (
                                <TableRow key={user.id} hover onClick={() => history.push(PATHS.CLINICIAN(user))} className={classes.row}>
                                    <TableCell>
                                        {/* PointerEvents set to none to stop propagation but link is still here for tabbing and a11y */}
                                        <Link component={RouterLink} to={PATHS.CLINICIAN(user)} style={{ pointerEvents: "none" }}>
                                            {user.displayName}
                                        </Link>
                                    </TableCell>
                                    <TableCell className={classes.capitalize}>{user.role}</TableCell>
                                    <TableCell className={classes.capitalize}>{user.status}</TableCell>
                                    <TableCell>{user.clients?.length ?? 0}</TableCell>
                                    <TableCell>
                                        <ClinicianMenu clinician={user} />
                                    </TableCell>
                                </TableRow>
                            ) : null
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}

export default observer(OrgPageTable)
